import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";

/** *
 * 时间处理
 * @type
 * @private
 */
var _ = {
  seconds2DHMS: function seconds2DHMS(diff) {
    var seconds = diff % 60;
    var minutes = (diff - seconds) % 3600; // const hours = (diff - minutes - seconds) % 86400;

    var hours = (diff - minutes - seconds) % 86400;
    var day = (diff - hours - minutes - seconds) / 86400;
    return [day, hours / 3600, minutes / 60, seconds];
  },
  seconds2HMS: function seconds2HMS(diff) {
    var seconds = diff % 60;
    var minutes = (diff - seconds) % 3600; // const hours = (diff - minutes - seconds) % 86400;

    var hours = diff - minutes - seconds;
    return [hours / 3600, minutes / 60, seconds];
  },
  secondsFormat: function secondsFormat(diff, format) {
    // eslint-disable-next-line no-param-reassign
    format = format || 'HH小时mm分';

    var val = _.seconds2HMS(diff);

    val = format.replace(/HH/g, val[0]).replace(/mm/g, val[1]).replace(/ss/g, val[2]);
    return val;
  },
  milliseconds2DHMS: function milliseconds2DHMS(diff) {
    var millisecond = diff % 1000; // eslint-disable-next-line no-param-reassign

    diff -= millisecond;
    return _.seconds2DHMS(diff / 1000);
  },
  milliseconds2HMS: function milliseconds2HMS(diff) {
    var millisecond = diff % 1000; // eslint-disable-next-line no-param-reassign

    diff -= millisecond;
    return _.seconds2HMS(diff / 1000);
  },
  toZeroStr: function toZeroStr(val) {
    var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    // eslint-disable-next-line no-param-reassign
    num = num || 2;
    return (new Array(num).join('0') + val).slice(-num);
  }
};
export default _;